const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const slowDown = "&slow";
const slowDown = "";

export async function fetchJson(path, options) {
    const url = `${BACKEND_URL}${path}${slowDown}`;

    let fetchOptions = {
        method: 'GET',
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    };

    if (options && options.signal) {
        fetchOptions.signal = options.signal;
    }

    const response = await fetch(url, fetchOptions);

    if (!response.ok) {
        throw new Error(`Response from server not OK: ${response.status}`);
    }

    return await response.json();
}